/*
 *
 * HeyLightPopup
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 04-Feb-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  title: (
    <PortalMessage
      id='t.app.services.heyLight.popup.title'
      defaultMessage='Sostituisci il tuo dispositivo per richiedere HeyLight'
    />
  ),
  description: (
    <PortalMessage
      id='t.app.services.heyLight.popup.description'
      defaultMessage='Per poter attivare il servizio HeyLight è necessario avere <strong>almeno uno SmartPOS</strong> sul tuo punto vendita. <br /> <strong>Richiedilo ora</strong> e sostituisci il tuo dispositivo.'
    />
  ),
  primaryButtonLabel: (
    <PortalMessage
      id='t.app.services.heyLight.popup.primaryButtonLabel'
      defaultMessage='Richiedi smartpos'
    />
  )
}

export default formattedMessage
